import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Re-exported so a caller needing the validator and its bounds has one import to reach for.
export { oneYearAheadISO, todayISO, toISODate, tomorrowISO } from './date-utils';

/**
 * Range check for a type="date" control, which yields an ISO yyyy-MM-dd string (or '' when cleared).
 * Bounds are compared as strings, which is safe for that format and avoids timezone drift from parsing
 * to Date.
 *
 * The bounds are thunks on purpose. A service-desk tab can stay open past midnight, and a floor captured
 * once would then still accept the now-stale prefill, leaving the backend to refuse it with a 400 from
 * @FutureOrPresent instead of the form saying so inline.
 *
 * allowEmpty separates the two callers: a manco always ships on a date, whereas an empty verkooporder
 * date is meaningful and maps to DeliveryDateTypeEnum.STANDARD in IOM.
 */
export const deliveryDateValidator =
  (min: () => string, max: () => string, allowEmpty = false): ValidatorFn =>
  (control: AbstractControl<string>): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return allowEmpty ? null : { invalidDeliveryDate: true };
    }
    if (value < min() || value > max()) {
      return { invalidDeliveryDate: true };
    }
    return null;
  };
